import { Form as FormContainer } from 'components/Form'
import { Form } from './Form'
import { schema, schemaDefaults } from './schema'
import { useCreateReports } from './useCreateReports'

import type { Schema } from './schema'

const FORM_ID: string = 'yieldbird-wrapper-agent-generate-report-form'

export const GenerateReportForm = (): React.JSX.Element => {
  const { create, errors: apiErrors, isPending, remainingUrls } = useCreateReports()

  return (
    <FormContainer<Schema>
      externalErrors={apiErrors}
      id={FORM_ID}
      onSubmit={create}
      schema={schema}
      schemaDefaults={schemaDefaults}
      withLeaveDialog={false}
    >
      {() => (
        <Form
          formId={FORM_ID}
          isPending={isPending}
          remainingUrls={remainingUrls}
        />
      )}
    </FormContainer>
  )
}
